import enAccessDenied from "src/locales/en/accessDenied.json";
import esAccessDenied from "src/locales/es/accessDenied.json";
import zhAccessDenied from "src/locales/zh/accessDenied.json";

const accessDeniedTerms = {
  en: enAccessDenied,
  es: esAccessDenied,
  zh: zhAccessDenied,
};

const getAccessDeniedTerms = lang => accessDeniedTerms[lang] || accessDeniedTerms.en;

export const WPAccessDeniedPageConstants = lang => {
  const terms = getAccessDeniedTerms(lang);
  return {
    accessNotSetupHeader: terms.accessDeniedPage.accessDeniedHeader,
    accessNotSetupDescription: terms.accessDeniedPage.accessDeniedDescription,
    profileSettings: terms.accessDeniedPage.profileSettings,
    howToEnable: terms.accessDeniedPage.howToEnable,
    contactSupport: terms.accessDeniedPage.contactSupport,
    clickToCompress: terms.clickToCompress,
    clickToExpand: terms.clickToExpand,
  };
};

export const WPEditProfileStepsPageConstants = lang => {
  const terms = getAccessDeniedTerms(lang);
  return {
    title: terms.editProfileStepsPage.title,
    description: terms.editProfileStepsPage.description,
    steps: [
      {
        instruction: terms.editProfileStepsPage.visitDupont,
        linkText: terms.editProfileStepsPage.website,
      },
      {
        instruction: terms.editProfileStepsPage.clickProfileIcon,
      },
      {
        instruction: terms.editProfileStepsPage.clickOnEdit,
      },
      {
        instruction: terms.editProfileStepsPage.selectWavePro,
      },
    ],
    clickToCompress: terms.clickToCompress,
    clickToExpand: terms.clickToExpand,
  };
};

export const accessSetupImages = lang => {
  if (lang === "zh") {
    return [
      { src: "images/AccessDeniedStep_1_zh.webp", alt: WPEditProfileStepsPageConstants(lang).title },
      { src: "images/AccessDeniedStep_2_zh.webp", alt: WPEditProfileStepsPageConstants(lang).title },
      { src: "images/AccessDeniedStep_3_zh.webp", alt: WPEditProfileStepsPageConstants(lang).title },
    ];
  } else if (lang === "es") {
    return [
      { src: "images/AccessDeniedStep_1_es.webp", alt: WPEditProfileStepsPageConstants(lang).title },
      { src: "images/AccessDeniedStep_2_es.webp", alt: WPEditProfileStepsPageConstants(lang).title },
      { src: "images/AccessDeniedStep_3_es.webp", alt: WPEditProfileStepsPageConstants(lang).title },
    ];
  }
  return [
    { src: "images/AccessDeniedStep_1.webp", alt: WPEditProfileStepsPageConstants(lang).title },
    { src: "images/AccessDeniedStep_2.webp", alt: WPEditProfileStepsPageConstants(lang).title },
    { src: "images/AccessDeniedStep_3.webp", alt: WPEditProfileStepsPageConstants(lang).title },
  ];
};

export const accessSetupImage = lang => {
  if (lang === "zh") {
    return [{ src: "images/accessDenied_zh.webp", alt: WPEditProfileStepsPageConstants(lang).title }];
  } else if (lang === "es") {
    return [{ src: "images/accessDenied_es.webp", alt: WPEditProfileStepsPageConstants(lang).title }];
  }
  return [{ src: "images/accessDenied.webp", alt: WPEditProfileStepsPageConstants(lang).title }];
};
export const imageStartIdx = 0;
export const imageEndIdx = 3;
